export default __webpack_public_path__ + "static/media/1718 utensils side.9f99c2cf.png";